import { useState, useEffect, useMemo } from 'react';
import { fetchStops } from '../services/api';
// 🔥 POPRAWIONY IMPORT: Używamy teraz FULL_STOP_MAP.js
import FULL_STOP_MAP from '../data/FULL_STOP_MAP.js'; 


function useStops(searchTerm, sortOrder, userLocation, calculateDistance) {
    const [stops, setStops] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
      const getStops = async () => {
        try {
          const data = await fetchStops();
          setStops(data);
          setLoading(false);
        } catch (err) {
          setError(err.message || 'Błąd podczas pobierania przystanków');
          setLoading(false);
        }
      };
      
      getStops();
    }, []);

    // Funkcja pomocnicza do tworzenia pełnej nazwy przystanku (UŻYWA TYLKO MAPY I LOGIKI AWARYJNEJ)
    const getFullStopName = (stop) => {
        const stopIdString = stop.stopId.toString();

        // 1. SPRAWDZENIE W MAPOWANIU
        const mappedName = FULL_STOP_MAP[stopIdString];
        
        if (mappedName) {
            // Jeśli znaleziono, zwracamy poprawną nazwę (np. "Witomino Centrum 01")
            return mappedName;
        }

        // 2. LOGIKA AWARYJNA (dla przystanków spoza mapy)
        // Jeśli Tristar dostarczył subName, łączymy je (np. dla niektórych starych przystanków w Gdańsku)
        if (stop.subName) {
            return `${stop.stopDesc} ${stop.subName}`;
        }
        
        // 3. Ostatecznie używamy głównej nazwy
        return stop.stopDesc;
    };

    // 1. BLOK FILTROWANIA (filteredStops)
    const filteredStops = useMemo(() => {
        return stops.filter(stop => {
            // 🔥 Używamy funkcji getFullStopName, która uwzględnia mapowanie
            const fullStopName = getFullStopName(stop);
            
            return fullStopName.toLowerCase().includes(searchTerm.toLowerCase());
        });
    }, [stops, searchTerm]);

    // 2. BLOK SORTOWANIA (sortedStops)
    const sortedStops = useMemo(() => {
        return [...filteredStops].sort((a, b) => {
            if (sortOrder === 'alphabetical') {
                // 🔥 Używamy funkcji getFullStopName do sortowania
                const nameA = getFullStopName(a).toLowerCase();
                const nameB = getFullStopName(b).toLowerCase();
                
                return nameA.localeCompare(nameB);
            } else if (sortOrder === 'code') {
                return a.stopCode - b.stopCode;
            } else if (sortOrder === 'distance' && userLocation) {
                const distA = calculateDistance(userLocation.latitude, userLocation.longitude, a.stopLat, a.stopLon);
                const distB = calculateDistance(userLocation.latitude, userLocation.longitude, b.stopLat, b.stopLon);
                return distA - distB;
            }
            return 0;
        });
    }, [filteredStops, sortOrder, userLocation]);

    return {
        stops,
        filteredStops,
        sortedStops,
        loading,
        error
    };
}

export default useStops;